import { INewsletterSubscribeRequest, NewsletterSubscribeResponseSchema } from '@/schemas/pages'
import { api, apiService } from '@/services/core/ApiService'

// ===== INSCREVER =====
/**
 * POST /newsletter/subscribe. Só no navegador (rodapé). O erro usa o tratador padrão: o 400 da API já traz a mensagem
 * para o cliente ("Erro ao cadastrar e-mail na newsletter..."); a confirmação de sucesso fica com a tela.
 */
export const subscribeNewsletterService = async (data: INewsletterSubscribeRequest): Promise<void> => {
    await apiService(api).post('/newsletter/subscribe', data, NewsletterSubscribeResponseSchema).execute()
}
